{
  "index": {
    "title": "Проекты",
    "newProject": "Новый проект",
    "catalog": "Каталог проектов",
    "badges": {
      "view": "Просмотр",
      "access": "Доступ",
      "settings": "Настройки",
      "demo": "Демо"
    },
    "progress": "Готовность",
    "createdAt": "Создано: {{date}}",
    "empty": {
      "title": "Пока нет проектов",
      "description": "Создайте первый через мастер"
    },
    "wizard": "Мастер создания",
    "noCover": "Нет обложки"
  },
  "home": {
    "inWork": "В работе",
    "inWorkHint": "Избранные и самые свежие по активности",
    "recentGenerations": "Последние генерации",
    "recentGenerationsHint": "Холст и шоты по всем проектам",
    "cast": "Персонажи",
    "castHint": "Герои проектов в работе",
    "allProjects": "Все проекты",
    "allProjectsCount": "{{count}} проектов",
    "filterPlaceholder": "Найти проект…",
    "filterEmpty": "Ничего не найдено",
    "lastShot": "Шот {{label}}",
    "activity": "активность {{when}}",
    "noActivity": "Пока без активности",
    "openCharacter": "{{name}} — открыть в героях проекта «{{project}}»"
  },
  "card": {
    "copyToCompany": "Скопировать в компанию",
    "addFavorite": "В избранное",
    "removeFavorite": "Убрать из избранного",
    "menuAria": "Действия с проектом",
    "copy": "Скопировать",
    "share": "Расшарить",
    "archive": "Архивировать"
  },
  "errors": {
    "favoriteFailed": "Не удалось обновить избранное"
  },
  "announcements": {
    "dismiss": "Скрыть объявление"
  },
  "copyDialog": {
    "title": "Скопировать проект",
    "source": "Источник: «{{name}}»",
    "close": "Закрыть",
    "targetCompany": "Целевая компания",
    "selectCompany": "Выберите компанию…",
    "copyName": "Название копии",
    "copyNamePlaceholder": "Новая копия",
    "note": "Копируется весь проект (включая переопределения промптов). Ассеты дублируются внутри ActiveStorage, внешние сервисы не вызываются.",
    "cancel": "Отмена",
    "submit": "Запустить копирование",
    "copySuffix": "{{name}} (копия)"
  },
  "shareDialog": {
    "title": "Расшарить проект",
    "source": "Проект: «{{name}}»",
    "close": "Закрыть",
    "company": "Компания",
    "selectCompany": "Выберите компанию…",
    "accessLevel": "Уровень доступа",
    "accessSettings": "Настройки и контент",
    "accessContent": "Контент (без настроек)",
    "accessView": "Только просмотр",
    "cancel": "Отмена",
    "submit": "Расшарить"
  },
  "wizard": {
    "headTitle": "Новый проект",
    "title": "Новый проект",
    "projectTypes": {
      "heading": "Тип проекта",
      "hint": "Тип задаёт сценарий работы, разделы и термины. После создания его нельзя изменить.",
      "serial": {
        "title": "Сериал",
        "description": "Полный производственный пайплайн для студий и продакшенов.",
        "structure": "Сезоны → Серии → Сцены → Шоты"
      },
      "stories": {
        "title": "Stories / Reels",
        "description": "Короткий вертикальный контент: Холст и Storyboard без лишних сущностей.",
        "structure": "Ролики"
      },
      "commercial": {
        "title": "Реклама",
        "description": "Тот же пайплайн, что у сериала, но с терминологией агентств.",
        "structure": "Кампании → Ролики → Сцены → Шоты"
      },
      "short_film": {
        "title": "Короткометражка",
        "description": "Один фильм: сразу сцены и шоты без сезонов и эпизодов.",
        "structure": "Сцены → Шоты"
      }
    },
    "nameLabel": "Название",
    "namePlaceholder": "Например: Неоновый этаж",
    "storyLabel": "Идея / логлайн",
    "storyPlaceholder": "Коротко: кто, конфликт, крючок для вертикального формата…",
    "teamLabel": "Команда проекта",
    "teamHint": "Кого добавить в проект. Выбранные получат роль «Участник».",
    "teamAssignAll": "Назначить всех",
    "seasonsLabel": "Сезоны",
    "campaignsLabel": "Рекламные кампании",
    "episodesPerSeasonLabel": "Серий на сезон",
    "spotsPerCampaignLabel": "Роликов в кампании",
    "reelsCountLabel": "Сколько роликов",
    "episodeDurationLabel": "Длительность серии (сек, макс. 600)",
    "spotDurationLabel": "Длительность ролика (сек, макс. 600)",
    "reelDurationLabel": "Длительность ролика (сек, макс. 600)",
    "filmDurationLabel": "Длительность фильма (сек, макс. 600)",
    "summaryType": "Тип:",
    "summaryFormatStories": "{{reels}} ролик(ов), по {{duration}} с",
    "summaryFormatShortFilm": "Фильм ~{{duration}} с",
    "genreLabel": "Жанр",
    "narrativeToneLabel": "Нарративный тон",
    "sectionStructure": "Структура и сюжет",
    "sectionVisual": "Визуальный стиль",
    "sectionMedium": "Визуальный медиум",
    "generationParamsTitle": "Параметры генерации",
    "generationParamsEmpty": "Настройки по умолчанию",
    "frameFormatLabel": "Формат кадра",
    "frameFormatHint": "Один формат на весь сериал: применяется ко всем API сториборда и видео, а также к превью в продакшен-блоке.",
    "genrePlaceholder": "Выберите жанр…",
    "tonePlaceholder": "Выберите нарративный тон…",
    "mediumPlaceholder": "Выберите медиум из каталога",
    "mediumSearchPlaceholder": "Поиск по каталогу…",
    "catalogStepRequired": "Выберите жанр и нарративный тон из каталога, чтобы продолжить.",
    "catalogEmpty": "Каталог стилей пуст. Обратитесь к администратору или запустите seed каталога.",
    "useCatalogStyles": "Стили каталога",
    "useCatalogStylesHint": "Жанр, нарративный тон и визуальный медиум подмешиваются во все генерации проекта. Можно создать бланковый проект без них.",
    "blankStylesSummary": "Без стилей",
    "summaryStyles": "Стили:",
    "uncategorizedGroup": "Без раздела",
    "mediumSelectButton": "Выбрать визуальный медиум",
    "mediumSkip": "Без стиля",
    "mediumSkipped": "Без стиля",
    "mediumModalTitle": "Выберите визуальный медиум",
    "mediumNoImage": "Нет превью",
    "mediumModalClose": "Закрыть",
    "mediumPreviewSelect": "Выбрать",
    "mediumNoResults": "Ничего не найдено",
    "textGenerationLabel": "Текст (структура, шоты)",
    "textProviderChatGpt": "ChatGPT через n8n",
    "storyboardImagesLabel": "Картинки сториборда",
    "videoPerShotsLabel": "Видео по шотам",
    "coverLabel": "Обложка проекта",
    "charactersRefLabel": "Герои (референс)",
    "locationsRefLabel": "Локации (референс)",
    "geminiModelLabel": "Модель Gemini",
    "veoModelLabel": "Модель Veo",
    "defaultFromStudio": "По умолчанию (Studio → AI)",
    "defaultFromStudioShort": "По умолчанию из Studio",
    "wanModelForProject": "Wan 2.7 image — модель для проекта",
    "qwenModelForProject": "Qwen Image — модель для проекта",
    "wanModelForCover": "Wan 2.7 Image — модель для обложки",
    "qwenModelForCover": "Qwen Image — модель для обложки",
    "wanModelForCharacters": "Wan 2.7 Image — модель для героев",
    "qwenModelForCharacters": "Qwen Image — модель для героев",
    "wanModelForLocations": "Wan 2.7 Image — модель для локаций",
    "qwenModelForLocations": "Qwen Image — модель для локаций",
    "modelLabel": "Модель",
    "resolutionLabel": "Разрешение",
    "generateSyncedAudio": "Генерировать синхронизированное аудио (Seedance / BytePlus)",
    "defaultSeedance": "По умолчанию (seedance-2.0)",
    "providerKling": "Kling",
    "providerGptImageN8n": "GPT Image через n8n",
    "providerQwenImage": "Qwen Image",
    "providerWanImage": "Wan 2.7 Image",
    "providerOpenRouter": "OpenRouter (Nano Banana 2)",
    "providerGoogleGeminiImage": "Google Gemini (image)",
    "providerByteplusSeedream": "BytePlus Seedream",
    "providerDashscopeQwen": "DashScope Qwen Image",
    "providerDashscopeWan": "DashScope Wan 2.7 Image",
    "providerOpenRouterNano": "OpenRouter (Nano Banana 2)",
    "providerWanVideo": "WAN (i2v / r2v)",
    "providerSeedanceOpenRouter": "Seedance 2.0 (OpenRouter)",
    "providerSeedanceBytePlus": "Seedance 2.0 (BytePlus)",
    "providerGoogleVeo": "Google Veo",
    "summaryName": "Название:",
    "summaryFormat": "Формат:",
    "summaryFormatValue": "{{seasons}} сезон(ов), {{episodes}} серий, по {{duration}} с",
    "summaryGenre": "Жанр:",
    "summaryNarrativeTone": "Нарративный тон:",
    "summaryVisualMedium": "Визуальный медиум:",
    "summaryFrameFormat": "Формат кадра:",
    "summaryStoryboard": "Сториборд:",
    "summaryVideo": "видео —",
    "summaryCover": "Обложка:",
    "summaryCharacters": "герои —",
    "summaryLocations": "локации —",
    "fromStudio": "из Studio",
    "autogenHeading": "Автогенерация через LLM",
    "autogenHint": "Выберите, что создать автоматически через AI. По умолчанию — заполнение вручную. Сезон и серии создаются всегда.",
    "scenesShots": "Сцены и шоты —",
    "characters": "Герои —",
    "locations": "Локации —",
    "modeAi": "AI (через LLM)",
    "modeManual": "вручную",
    "afterCreateWithAutogen": "После создания в фоне запустится генерация: сезон, серии{{scenes}}{{characters}}{{locations}}. Прогресс отображается в виджете задач. Сториборд и видео генерируются отдельно.",
    "afterCreateManual": "После создания будут созданы сезон и серии. Сцены, шоты, героев и локации вы заполните вручную в workspace.",
    "autogenScenes": ", сцены и шоты",
    "autogenCharacters": ", герои",
    "autogenLocations": ", локации",
    "back": "Назад",
    "next": "Далее",
    "creating": "Создание…",
    "createAndGenerate": "Создать и сгенерировать",
    "createProject": "Создать проект"
  },
  "feed": {
    "title": "Лента",
    "headTitle": "Лента студии",
    "beta": "бета",
    "classicView": "Прежний вид",
    "openFeed": "Лента",
    "markRead": "прочитано",
    "studio": "Вся студия",
    "navSearch": "Найти проект",
    "tabs": {
      "all": "Всё",
      "review": "Ждут решения",
      "ready": "Готовое",
      "generations": "Генерации",
      "tasks": "Задачи",
      "team": "Команда"
    },
    "attention": {
      "lead": "Ждёт вас:",
      "shots_one": "{{count}} шот на проверке",
      "shots_few": "{{count}} шота на проверке",
      "shots_many": "{{count}} шотов на проверке",
      "shots_other": "{{count}} шота на проверке",
      "assets_one": "{{count}} ассет на проверке",
      "assets_few": "{{count}} ассета на проверке",
      "assets_many": "{{count}} ассетов на проверке",
      "assets_other": "{{count}} ассета на проверке",
      "tasks_one": "{{count}} задача · срок {{when}}",
      "tasks_few": "{{count}} задачи · срок {{when}}",
      "tasks_many": "{{count}} задач · срок {{when}}",
      "tasks_other": "{{count}} задачи · срок {{when}}",
      "whenOverdue": "прошёл",
      "whenToday": "сегодня",
      "whenTomorrow": "завтра",
      "balanceOut": "баланс закончился",
      "balanceLow_one": "баланса хватит на {{count}} день",
      "balanceLow_few": "баланса хватит на {{count}} дня",
      "balanceLow_many": "баланса хватит на {{count}} дней",
      "balanceLow_other": "баланса хватит на {{count}} дня",
      "balanceUnderDay": "баланса не хватит и на день",
      "topUp": "пополнить"
    },
    "running": {
      "title": "Сейчас генерируется · {{count}}",
      "hint": "обновляется само",
      "queued": "в очереди",
      "stop": "Остановить",
      "stopConfirm": "Остановить «{{label}}» принудительно? Генерация будет отменена, резерв баланса вернётся. Используйте для зависших задач, которые не завершаются сами.",
      "stopFailed": "Не удалось остановить генерацию",
      "stale": "давно без движения"
    },
    "days": {
      "today": "Сегодня",
      "yesterday": "Вчера"
    },
    "event": {
      "someone": "Кто-то",
      "you": "Вы",
      "assistant": "Ассистент",
      "shotFrames_one": "сгенерировал {{count}} кадр",
      "shotFrames_you_one": "сгенерировали {{count}} кадр",
      "shotFrames_few": "сгенерировал {{count}} кадра",
      "shotFrames_you_few": "сгенерировали {{count}} кадра",
      "shotFrames_many": "сгенерировал {{count}} кадров",
      "shotFrames_you_many": "сгенерировали {{count}} кадров",
      "shotFrames_other": "сгенерировал {{count}} кадра",
      "shotFrames_you_other": "сгенерировали {{count}} кадра",
      "shotVideos_one": "сгенерировал {{count}} видео",
      "shotVideos_you_one": "сгенерировали {{count}} видео",
      "shotVideos_few": "сгенерировал {{count}} видео",
      "shotVideos_you_few": "сгенерировали {{count}} видео",
      "shotVideos_many": "сгенерировал {{count}} видео",
      "shotVideos_you_many": "сгенерировали {{count}} видео",
      "shotVideos_other": "сгенерировал {{count}} видео",
      "shotVideos_you_other": "сгенерировали {{count}} видео",
      "canvasItems_one": "сгенерировал {{count}} изображение на холсте",
      "canvasItems_you_one": "сгенерировали {{count}} изображение на холсте",
      "canvasItems_few": "сгенерировал {{count}} изображения на холсте",
      "canvasItems_you_few": "сгенерировали {{count}} изображения на холсте",
      "canvasItems_many": "сгенерировал {{count}} изображений на холсте",
      "canvasItems_you_many": "сгенерировали {{count}} изображений на холсте",
      "canvasItems_other": "сгенерировал {{count}} изображения на холсте",
      "canvasItems_you_other": "сгенерировали {{count}} изображения на холсте",
      "canvasVideos_one": "сгенерировал {{count}} видео на холсте",
      "canvasVideos_you_one": "сгенерировали {{count}} видео на холсте",
      "canvasVideos_few": "сгенерировал {{count}} видео на холсте",
      "canvasVideos_you_few": "сгенерировали {{count}} видео на холсте",
      "canvasVideos_many": "сгенерировал {{count}} видео на холсте",
      "canvasVideos_you_many": "сгенерировали {{count}} видео на холсте",
      "canvasVideos_other": "сгенерировал {{count}} видео на холсте",
      "canvasVideos_you_other": "сгенерировали {{count}} видео на холсте",
      "scene": "Сцена {{number}}",
      "sceneTitled": "Сцена {{number}} «{{title}}»",
      "reviewWaiting_one": "{{count}} ждёт решения",
      "reviewWaiting_few": "{{count}} ждут решения",
      "reviewWaiting_many": "{{count}} ждут решения",
      "reviewWaiting_other": "{{count}} ждут решения",
      "checkShots_one": "Проверить {{count}} шот",
      "checkShots_few": "Проверить {{count}} шота",
      "checkShots_many": "Проверить {{count}} шотов",
      "checkShots_other": "Проверить {{count}} шота",
      "openCanvas": "Открыть холст",
      "more": "+{{count}}",
      "failure": "Не сгенерировалось: {{what}}",
      "failureSeries": "Не сгенерировалось {{count}} раз подряд: {{what}}",
      "retryHint": "откройте и запустите заново",
      "openJob": "Открыть",
      "assembly": "Собрана серия {{label}}",
      "assemblyNoLabel": "Собрана серия",
      "watch": "Смотреть",
      "download": "Скачать",
      "assets": {
        "character_one": "Новый герой",
        "character_few": "Новые герои · {{count}}",
        "character_many": "Новые герои · {{count}}",
        "character_other": "Новые герои · {{count}}",
        "location_one": "Новая локация",
        "location_few": "Новые локации · {{count}}",
        "location_many": "Новые локации · {{count}}",
        "location_other": "Новые локации · {{count}}",
        "prop_one": "Новый реквизит",
        "prop_few": "Новый реквизит · {{count}}",
        "prop_many": "Новый реквизит · {{count}}",
        "prop_other": "Новый реквизит · {{count}}"
      },
      "openAssets": "Открыть",
      "taskAssigned": "назначил вам задачу",
      "taskMentioned": "упомянул вас в задаче",
      "taskDue": "срок {{date}}",
      "taskCreated_one": "завёл задачу",
      "taskCreated_you_one": "завели задачу",
      "taskCreated_few": "завёл {{count}} задачи",
      "taskCreated_you_few": "завели {{count}} задачи",
      "taskCreated_many": "завёл {{count}} задач",
      "taskCreated_you_many": "завели {{count}} задач",
      "taskCreated_other": "завёл {{count}} задачи",
      "taskCreated_you_other": "завели {{count}} задачи",
      "taskCreatedMore_one": "и ещё {{count}}",
      "taskCreatedMore_few": "и ещё {{count}}",
      "taskCreatedMore_many": "и ещё {{count}}",
      "taskCreatedMore_other": "и ещё {{count}}",
      "taskToYou": "вам",
      "openTask": "Открыть задачу",
      "memberJoined": "присоединился к студии",
      "memberJoined_you": "присоединились к студии",
      "addToProject": "Участники",
      "canvasFallback": "Холст",
      "memberJoinedProject": "присоединился к проекту",
      "memberJoinedProject_you": "присоединились к проекту",
      "projectTeam": "Команда проекта"
    },
    "empty": {
      "title": "Пока тихо",
      "text": "Здесь появятся генерации, сборки, задачи и действия ассистента во всех проектах студии."
    },
    "loadingMore": "Загружаю ещё…",
    "end": "Раньше событий нет",
    "loadMore": "Загрузить ещё",
    "loadFailed": "Не загрузилось — попробуйте ещё раз",
    "filterEmpty": "Таких событий в этом периоде нет",
    "start": {
      "modes": {
        "project": "Новый проект",
        "canvas": "Холст"
      },
      "examples": "Например",
      "project": {
        "intro": "Опишите, что хотите снять. Ассистент предложит проект — формат, героев, места и первые сцены. Ничего не создастся без вашего подтверждения.",
        "placeholder": "История, герои, настроение, сколько серий или минут",
        "format": "Формат:",
        "formatAuto": "определит ассистент",
        "submit": "Предложить проект",
        "message": "Предложи проект по этой идее:\n\n{{idea}}",
        "messageTyped": "Предложи проект, формат — {{format}}, по этой идее:\n\n{{idea}}",
        "examples": {
          "camp": "Вожатые в лагере 1987 года ищут пропавший горн. 5 серий по минуте, тревожно и смешно.",
          "robot": "Робот-доставщик и ёжики спасают зимнюю доставку на Арбате. 2 минуты.",
          "coffee": "Три рилса для кофейни: бариста-робот учится латте-арту."
        },
        "noAssistant": "Можно и без ассистента —",
        "wizard": "мастер создания"
      },
      "canvas": {
        "intro": "Кадры и видео без проекта. Всё сохранится в холсте компании — из любого кадра потом можно начать проект.",
        "examples": {
          "street": "Ночная улица старой Москвы в снегу, робот-доставщик у окна кафе, тёплые витрины.",
          "kolobok": "Колобок остывает на подоконнике, русская книжная иллюстрация.",
          "colonel": "Полковник в кабинете смеётся и крутит карандаш, 1980-е, 5 секунд."
        },
        "results": "Результаты — в",
        "board": "холсте компании"
      }
    },
    "navFavorites": "Избранные",
    "navOthers": "Остальные",
    "navAll": "Проекты",
    "navMore": "Показать ещё {{count}}",
    "navNothing": "Проектов не нашлось",
    "navMoreOf": "Показать ещё {{count}} · осталось {{total}}",
    "kindsNav": "Типы событий проекта",
    "wholeProject": "Весь проект",
    "projectHeadTitle": "Лента · {{name}}",
    "kinds": {
      "shots": "Шоты",
      "canvas": "Холст",
      "assembly": "Сборки",
      "character": "Герои",
      "location": "Локации",
      "prop": "Реквизит",
      "tasks": "Задачи",
      "team": "Команда",
      "failures": "Ошибки"
    },
    "filters": {
      "all": "Всё",
      "review": "Ждут решения",
      "ready": "Готовое",
      "generations": "Генерации",
      "image": "Кадры",
      "video": "Видео",
      "failures": "Ошибки",
      "mine": "Мне"
    }
  },
  "review": {
    "title": "Проверка шотов",
    "position": "{{index}} из {{total}}",
    "close": "Закрыть проверку",
    "prev": "Предыдущий шот",
    "next": "Следующий шот",
    "loading": "Загружаю шот…",
    "shot": "Шот {{label}}",
    "scene": "Сцена {{number}} «{{title}}»",
    "seconds_one": "{{count}} с",
    "seconds_few": "{{count}} с",
    "seconds_many": "{{count}} с",
    "seconds_other": "{{count}} с",
    "openShot": "открыть шот",
    "current": "текущая",
    "versionBadge": "версия {{number}}",
    "prompt": "Промпт",
    "promptExpand": "раскрыть промпт",
    "promptCollapse": "свернуть промпт",
    "kinds": {
      "storyboard": "кадр",
      "video": "видео"
    },
    "tabs": {
      "storyboard": "Кадр · {{count}}",
      "video": "Видео · {{count}}"
    },
    "versionsTitle": {
      "storyboard": "Версии кадра · {{count}}",
      "video": "Версии видео · {{count}}"
    },
    "empty": {
      "storyboard": "Кадров у шота ещё нет.",
      "video": "Видео у шота ещё нет."
    },
    "states": {
      "draft": "черновик",
      "generated": "сгенерирован",
      "in_review": "на проверке",
      "approved": "принят",
      "needs_changes": "нужны правки",
      "locked": "зафиксирован",
      "failed": "ошибка"
    },
    "compare": {
      "start": "сравнить",
      "done": "готово",
      "side": "Рядом",
      "wipe": "Шторка",
      "hint": "Выберите две версии для сравнения.",
      "playBoth": "Играть обе",
      "pauseBoth": "Пауза",
      "fromStart": "С начала",
      "pick": "Выбрать для сравнения"
    },
    "tasks": {
      "title": "Задачи по шоту",
      "empty": "Задач по шоту нет — «Переделать» заведёт её в трекере.",
      "comments_one": "{{count}} комментарий",
      "comments_few": "{{count}} комментария",
      "comments_many": "{{count}} комментариев",
      "comments_other": "{{count}} комментария",
      "closesOnApprove": "закроется при «Принять»",
      "add": "+ задача",
      "newPlaceholder": "Что сделать — например, добавить шарф",
      "create": "Создать"
    },
    "redoAction": "Переделать",
    "approveAction": "Принять",
    "approved": "Шот {{label}} принят",
    "queue": "Очередь · шоты на проверке в ваших проектах",
    "redo": {
      "whatToFix": "Что поправить",
      "placeholder": "Что не так и как должно быть — уйдёт в задачу или ассистенту",
      "chips": {
        "light": "Свет",
        "composition": "Композиция",
        "character": "Не похож герой",
        "style": "Не тот стиль"
      },
      "notes": {
        "light": "Свет: ",
        "composition": "Композиция: ",
        "character": "Герой не похож на референс: ",
        "style": "Стиль не совпадает с проектом: "
      },
      "previous": "Прошлое решение: «{{comment}}»",
      "who": "Кто переделает",
      "routes": {
        "assistant": {
          "title": "Ассистент шота",
          "text": "Получит задачу и сразу перегенерирует по комментарию. Новая версия вернётся в очередь."
        },
        "person": {
          "title": "Человек — через задачу",
          "text": "Комментарий уйдёт в трекер, исполнитель получит уведомление."
        }
      },
      "reopen": "Вернуть {{key}} в работу",
      "reopenHint": "комментарий — в задачу",
      "newTask": "Новая задача",
      "versionAuthor": "автор версии",
      "attached": "Приложится",
      "attachedValue": "{{version}} и ссылка на шот {{shot}}",
      "cancel": "Отмена",
      "statusHint": "шот получит статус «Нужны правки»",
      "submitAssistant": "Передать ассистенту",
      "submitReopen": "Вернуть в работу",
      "submitTask": "Создать задачу",
      "done": {
        "person": "Задача {{key}} — в трекере",
        "assistant": "Задача {{key}} передана ассистенту шота"
      }
    },
    "queueEmpty": "Шотов на проверке нет.",
    "asset": {
      "title": "Проверка ассетов",
      "kinds": {
        "character": "герой",
        "location": "локация",
        "prop": "реквизит"
      },
      "inShots_one": "в {{count}} шоте",
      "inShots_few": "в {{count}} шотах",
      "inShots_many": "в {{count}} шотах",
      "inShots_other": "в {{count}} шотах",
      "open": {
        "character": "открыть героя",
        "location": "открыть локацию",
        "prop": "открыть реквизит"
      },
      "slots": {
        "reference": "Референс",
        "portrait": "Портрет",
        "sheet": "Лист персонажа",
        "emotions": "Эмоции",
        "three_quarter": "Вид 3/4",
        "north": "Север",
        "south": "Юг",
        "east": "Восток",
        "west": "Запад",
        "topview": "Сверху",
        "front": "Вид спереди"
      },
      "versionsTitle": "Версии · {{slot}} · {{count}}",
      "empty": "У ассета ещё нет изображений.",
      "origins": {
        "generated": "сгенерирована",
        "uploaded": "загружена"
      },
      "afterApprove": "После принятия",
      "usage_one": "станет референсом для {{count}} шота",
      "usage_few": "станет референсом для {{count}} шотов",
      "usage_many": "станет референсом для {{count}} шотов",
      "usage_other": "станет референсом для {{count}} шотов",
      "withFrames_one": "{{count}} из них уже с кадром",
      "withFrames_few": "{{count}} из них уже с кадрами",
      "withFrames_many": "{{count}} из них уже с кадрами",
      "withFrames_other": "{{count}} из них уже с кадрами",
      "assistant": {
        "character": "Ассистент героев",
        "location": "Ассистент локаций",
        "prop": "Ассистент реквизита"
      },
      "attachedValue": "{{what}} и упоминание «{{name}}»",
      "approved": "«{{name}}» принят",
      "queue": "Очередь · ассеты на проверке в ваших проектах",
      "queueEmpty": "Ассетов на проверке нет.",
      "tasksTitle": "Задачи по ассету",
      "tasksEmpty": "Задач нет — «Переделать» заведёт её в трекере, а задачи с упоминанием ассета появятся здесь.",
      "statusHint": "ассет получит статус «Нужны правки»"
    },
    "media": {
      "unavailable": "Файл недоступен.",
      "openCanvas": "Открыть на холсте",
      "openFlow": "Открыть во флоу",
      "flowVideos": "Видео флоу · {{count}}",
      "flowFrames": "Кадры флоу · {{count}}",
      "openAssembly": "Открыть в монтаже",
      "model": "Модель",
      "references": "Референсы",
      "format": "Формат",
      "loading": "Загружаю вводные…"
    }
  }
}
